import React, { useContext, useRef, useEffect } from 'react'
import styled from 'styled-components'
import loadable from '@loadable/component'

import Header from './Header'
import Cart from './Cart'
import CurrencyPopIn from './CurrencyPopIn'
import { LayoutContext } from '../../contexts'
import { getSessionStorageSessionStartedKey as getSessionKey } from '../../utils'
import { useSessionStartedTracking } from '../../hooks/tracking'

const Aside = loadable(() => import('./Aside'))
const Search = loadable(() => import('./Search'))
const ConsentManager = loadable(() => import('./consentManager'))
const Footer = loadable(() => import('./Footer'))

const Layout = ({ children }) => {
  const wrapperEl = useRef()
  const {
    name: layoutName,
    headerStyle: { announcementVisible },
    node_locale,
    currency,
  } = useContext(LayoutContext)

  useEffect(() => {
    // Send tracking of event only 1 time per session -use sessionStorage item to check if it's already there
    if (!sessionStorage.getItem(getSessionKey())) {
      useSessionStartedTracking({
        currency: currency?.code,
        locale: node_locale,
      })
      sessionStorage.setItem(getSessionKey(), 'true')
    }
  }, [children]) // Wait until children exist so window.analytics also exists

  return (
    <div data-layout-name={layoutName}>
      <Header ref={wrapperEl} />
      <Aside wrapperEl={wrapperEl} />
      <Cart wrapperEl={wrapperEl} announcementVisible={announcementVisible} />
      <CurrencyPopIn />
      <Search wrapperEl={wrapperEl} announcementVisible={announcementVisible} />
      <ConsentManager />
      <StyledMain>{children}</StyledMain>
      <Footer />
    </div>
  )
}

const StyledMain = styled.main`
  /* for lazy loading sections in Home.js and Product.js */
  position: relative;
`

export default Layout
